module.exports = __webpack_public_path__ + "img/f09e98a.png";